module.exports = __webpack_public_path__ + "asset/image/light-off-5e7f.svg";